export default __webpack_public_path__ + "static/media/programme.dc1af98c.png";